module.exports = __webpack_public_path__ + "static/media/game-news.8d2fc4fe.png";